import { connectRefinementList } from 'instantsearch.js/es/connectors';

const sortBy = ['isRefined'];
const getSortingControls = () => {
  return html``;
  // <span class="flex flex-row flex-nowrap space-x-2">
  //   <a
  //     href="#"
  //     class="flex flex-row flex-nowrap items-end text-sm text-primary-500 underline"
  //     >Popular</a
  //   >
  //   <a
  //     href="#"
  //     class="flex flex-row flex-nowrap items-end text-sm text-primary-500 underline"
  //   >
  //     <svg
  //       class="w-4 h-4"
  //       fill="none"
  //       stroke-linecap="round"
  //       stroke-linejoin="round"
  //       stroke-width="2"
  //       stroke="currentColor"
  //       viewBox="0 0 24 24"
  //     >
  //       <path d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"></path>
  //     </svg>
  //     A-Z
  //   </a>
  // </span>
};

const renderItems = (widgetParams, items) => {
  return html`
    <fieldset>
      <div class="px-4 py-5 bg-white border-b border-gray-200">
        <div class="flex flex-wrap items-baseline justify-between">
          <legend class="text-base font-medium text-gray-500">${widgetParams.title}</legend>

          ${getSortingControls()}
        </div>
      </div>

      <div class="bg-white border-b border-gray-200">
        <div class="refinementListItems h-40 overflow-y-scroll divide-y divide-gray-100">
          ${items.length
            ? items.map((item) => itemTemplate(item, widgetParams.title)).join('')
            : nullTemplate(widgetParams.title)}
        </div>
      </div>
    </fieldset>
  `;
};

const itemTemplate = (item, title) => html`
  <div class="py-1">
    <label class="flex items-center py-2 pl-6 cursor-pointer">
      <input
        type="checkbox"
        name="${window.encodeURIComponent(title)}"
        value="${item.value}"
        ${item.isRefined ? 'checked' : ''}
        class="w-4 h-4 text-primary-600 border-gray-300 rounded focus:ring-primary-500"
      />

      <span class="ml-3">
        <span class="inline-block text-sm">${item.label}</span>
        <span class="text-xs text-gray-500">${item.count}</span>
      </span>
    </label>
  </div>
`;

const nullTemplate = (title) => html`
  <div class="py-1">
    <div class="py-2 pl-6 text-sm">
      <span class="inline-block text-sm">${title} not found.</span>
    </div>
  </div>
`;

const renderRefinementList = (renderOptions, isFirstRender) => {
  const { items, widgetParams, refine } = renderOptions;
  const $container = widgetParams.container;

  $container.innerHTML = renderItems(widgetParams, items);

  [...$container.querySelectorAll('input')].forEach((element) => {
    element.addEventListener('click', (event) => {
      event.preventDefault();
      refine(event.currentTarget.value);
    });
  });
};

const connectedRefinementList = connectRefinementList(renderRefinementList);

export const refinementList = ({ container, attribute, title }) =>
  connectedRefinementList({
    container,
    attribute,
    limit: 100,
    title: title || 'Refinements',
    sortBy,
  });
